export const parseIntOrNull = (value: string): number | null => {
  const intOrNaN = Number.parseInt(value, 10)
  return Number.isNaN(intOrNaN) ? null : intOrNaN
}

export const parseStringToFixed = (
  value: string | undefined,
  precision: number,
): string | undefined => {
  if (!value) {
    return undefined
  }

  const parsed = +value
  if (Number.isNaN(value)) {
    return undefined
  }

  return parsed.toFixed(precision)
}

/**
 * Formats a number using fixed-point notation but removes padding zeros
 * e.g. toFixedWithoutPadding(18, 2) does NOT return '18.00' but '18' instead
 * however toFixedWithoutPadding(18.12345, 2) still returns '18.12'
 * @param value
 * @param digits
 */
export const toFixedWithoutPadding = (
  value: number | undefined,
  digits: number,
) => {
  if (value === undefined) {
    return undefined
  }

  return Number.parseFloat(value.toFixed(digits)).toString()
}
